"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2817],{

/***/ 61527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "II": function() { return /* reexport */ Input; },
  "Ph": function() { return /* reexport */ Select; },
  "gx": function() { return /* reexport */ Textarea; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/foundation.js
var foundation = __webpack_require__(90593);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/Icon.js
var Icon = __webpack_require__(55803);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/IconList.js
var IconList = __webpack_require__(34898);
;// CONCATENATED MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/Input.js
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






var inputCSS = function (isDisabled) { return function (theme) {
    return (0,emotion_react_browser_esm.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", "px;\n    outline: none;\n    border: none;\n    padding: ", "px;\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n    border-radius: ", "px;\n\n    i + input,\n    input + i {\n      margin-left: ", "px;\n    }\n\n    input {\n      border: none;\n      outline: none;\n      flex-grow: 1;\n      width: 100px;\n      background-color: transparent;\n      color: ", ";\n\n      &:disabled {\n        color: ", ";\n        // iOS Safari fix\n        -webkit-text-fill-color: ", ";\n        opacity: 1;\n      }\n\n      &::placeholder {\n        color: ", ";\n      }\n    }\n\n    button {\n      padding: 4px;\n      margin: -4px;\n      border: none;\n      background-color: transparent;\n      font-size: 0;\n      margin-left: ", "px;\n    }\n  "], ["\n    font-size: ", "px;\n    outline: none;\n    border: none;\n    padding: ", "px;\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n    border-radius: ", "px;\n\n    i + input,\n    input + i {\n      margin-left: ", "px;\n    }\n\n    input {\n      border: none;\n      outline: none;\n      flex-grow: 1;\n      width: 100px;\n      background-color: transparent;\n      color: ", ";\n\n      &:disabled {\n        color: ", ";\n        // iOS Safari fix\n        -webkit-text-fill-color: ", ";\n        opacity: 1;\n      }\n\n      &::placeholder {\n        color: ", ";\n      }\n    }\n\n    button {\n      padding: 4px;\n      margin: -4px;\n      border: none;\n      background-color: transparent;\n      font-size: 0;\n      margin-left: ", "px;\n    }\n  "])), foundation/* FontSizes.medium */.TS.medium, foundation/* Spacing.medium */.Ki.medium, isDisabled ? theme.var.gray100 : theme.var.gray50, foundation/* Radius.medium */.wU.medium, foundation/* Spacing.xsmall */.Ki.xsmall, theme.var.black, theme.var.gray400, theme.var.gray400, theme.var.gray600, foundation/* Spacing.xxsmall */.Ki.xxsmall);
}; };
var Input = (0,react.forwardRef)(function (_a, ref) {
    var className = _a.className, icon = _a.icon, value = _a.value, onClear = _a.onClear, props = __rest(_a, ["className", "icon", "value", "onClear"]);
    var disabled = props.disabled;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    return ((0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", __assign({ className: className, css: inputCSS(disabled !== null && disabled !== void 0 ? disabled : false) }, { children: [icon, (0,emotion_react_jsx_runtime_browser_esm.jsx)("input", __assign({ ref: ref, value: value }, props)), onClear && value && !disabled && ((0,emotion_react_jsx_runtime_browser_esm.jsx)("button", __assign({ onClick: onClear, type: "button" }, { children: (0,emotion_react_jsx_runtime_browser_esm.jsx)(Icon/* default */.Z, { icon: IconList/* XCircle */.IW, size: foundation/* Sizes.small */.u8.small, color: theme.var.gray500 }) })))] })));
});
/* harmony default export */ var form_Input = ((/* unused pure expression or super */ null && (Input)));
var templateObject_1;
//# sourceMappingURL=Input.js.map
;// CONCATENATED MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/css.js
var css_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var multiline = (0,emotion_react_browser_esm.css)(css_templateObject_1 || (css_templateObject_1 = css_makeTemplateObject(["\n  line-height: 135%;\n  white-space: pre-line;\n  word-break: break-all;\n"], ["\n  line-height: 135%;\n  white-space: pre-line;\n  word-break: break-all;\n"])));
var ellipsis = (0,emotion_react_browser_esm.css)(templateObject_2 || (templateObject_2 = css_makeTemplateObject(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  line-height: 135%;\n"], ["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  line-height: 135%;\n"])));
var css_templateObject_1, templateObject_2;
//# sourceMappingURL=css.js.map
;// CONCATENATED MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/Select.js
var Select_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var Select_assign = (undefined && undefined.__assign) || function () {
    Select_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Select_assign.apply(this, arguments);
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};







var selectWrapCSS = function (fontSize) { return function (theme) {
    return (0,emotion_react_browser_esm.css)(Select_templateObject_1 || (Select_templateObject_1 = Select_makeTemplateObject(["\n    position: relative;\n    user-select: none;\n    font-size: ", "px;\n\n    ul {\n      position: absolute;\n      width: 100%;\n      top: 0;\n      background-color: ", ";\n      border-radius: ", "px;\n      max-height: 180px;\n      overflow: auto;\n      box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);\n      z-index: 9;\n      transition: 0.1s ease-out;\n      transform: scale(1);\n\n      &.hidden {\n        opacity: 0;\n        visibility: hidden;\n        transform: scale(0.9);\n      }\n\n      li {\n        padding: ", "px;\n        cursor: pointer;\n\n        &.selected {\n          color: #45b7d0;\n        }\n      }\n    }\n  "], ["\n    position: relative;\n    user-select: none;\n    font-size: ", "px;\n\n    ul {\n      position: absolute;\n      width: 100%;\n      top: 0;\n      background-color: ", ";\n      border-radius: ", "px;\n      max-height: 180px;\n      overflow: auto;\n      box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);\n      z-index: 9;\n      transition: 0.1s ease-out;\n      transform: scale(1);\n\n      &.hidden {\n        opacity: 0;\n        visibility: hidden;\n        transform: scale(0.9);\n      }\n\n      li {\n        padding: ", "px;\n        cursor: pointer;\n\n        &.selected {\n          color: #45b7d0;\n        }\n      }\n    }\n  "])), fontSize, theme.var.gray50, foundation/* Radius.medium */.wU.medium, foundation/* Spacing.medium */.Ki.medium);
}; };
var selectCSS = function (isDisabled) { return function (theme) {
    return (0,emotion_react_browser_esm.css)(Select_templateObject_2 || (Select_templateObject_2 = Select_makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding: ", "px;\n    background-color: ", ";\n    border-radius: ", "px;\n    cursor: ", ";\n\n    p {\n      flex-grow: 1;\n      padding-right: ", "px;\n      color: ", ";\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    padding: ", "px;\n    background-color: ", ";\n    border-radius: ", "px;\n    cursor: ", ";\n\n    p {\n      flex-grow: 1;\n      padding-right: ", "px;\n      color: ", ";\n    }\n  "])), foundation/* Spacing.medium */.Ki.medium, isDisabled ? theme.var.gray100 : theme.var.gray50, foundation/* Radius.medium */.wU.medium, isDisabled ? 'not-allowed' : 'pointer', foundation/* Spacing.small */.Ki.small, isDisabled ? theme.var.gray400 : theme.var.black);
}; };
var Select = function (_a) {
    var className = _a.className, name = _a.name, selected = _a.selected, placeholder = _a.placeholder, options = _a.options, optionStyle = _a.optionStyle, _b = _a.fontSize, fontSize = _b === void 0 ? foundation/* FontSizes.medium */.TS.medium : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, onChange = _a.onChange;
    var _d = __read((0,react.useState)(false), 2), isOpen = _d[0], setOpen = _d[1];
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var handleSelect = (0,react.useCallback)(function (option) {
        onChange === null || onChange === void 0 ? void 0 : onChange(option);
        setOpen(false);
    }, []);
    return ((0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", Select_assign({ className: className, css: selectWrapCSS(fontSize) }, { children: [(0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", Select_assign({ css: selectCSS(disabled), onClick: disabled ? undefined : onClick !== null && onClick !== void 0 ? onClick : (function () { return setOpen(function (prev) { return !prev; }); }) }, { children: [(0,emotion_react_jsx_runtime_browser_esm.jsx)("p", Select_assign({ css: ellipsis }, { children: selected ? selected.label : placeholder })), (0,emotion_react_jsx_runtime_browser_esm.jsx)(Icon/* default */.Z, { icon: isOpen ? IconList/* ArrowUp */.a2 : IconList/* ArrowDown */.K5, size: foundation/* Sizes.small */.u8.small, color: disabled ? theme.var.gray400 : theme.var.black })] })), (0,emotion_react_jsx_runtime_browser_esm.jsx)("ul", Select_assign({ className: isOpen ? undefined : 'hidden', style: optionStyle }, { children: options === null || options === void 0 ? void 0 : options.map(function (option) { return ((0,emotion_react_jsx_runtime_browser_esm.jsx)("li", Select_assign({ onClick: function () { return handleSelect(option); }, className: (selected === null || selected === void 0 ? void 0 : selected.value) === option.value ? 'selected' : undefined }, { children: (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", Select_assign({ css: multiline }, { children: option.label })) }), "select-".concat(name, "-").concat(option.value))); }) }))] })));
};
/* harmony default export */ var form_Select = ((/* unused pure expression or super */ null && (Select)));
var Select_templateObject_1, Select_templateObject_2;
//# sourceMappingURL=Select.js.map
// EXTERNAL MODULE: ./.yarn/__virtual__/react-textarea-autosize-virtual-b25d8b70b8/0/cache/react-textarea-autosize-npm-8.5.3-27299c7990-b317c3763f.zip/node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 3 modules
var react_textarea_autosize_browser_esm = __webpack_require__(84490);
;// CONCATENATED MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/Textarea.js
var Textarea_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var Textarea_assign = (undefined && undefined.__assign) || function () {
    Textarea_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Textarea_assign.apply(this, arguments);
};
var Textarea_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





var textareaCSS = function (fontSize, minHeight, isDisabled) {
    return function (theme) {
        return (0,emotion_react_browser_esm.css)(Textarea_templateObject_1 || (Textarea_templateObject_1 = Textarea_makeTemplateObject(["\n      min-height: ", "px;\n      padding: ", "px;\n      border-radius: ", "px;\n      background-color: ", ";\n\n      textarea {\n        display: block;\n        width: 100%;\n        resize: none;\n        border: none;\n        outline: none;\n        font-size: ", "px;\n        background-color: transparent;\n        color: ", ";\n\n        &:disabled {\n          color: ", ";\n          // iOS Safari fix\n          -webkit-text-fill-color: ", ";\n          opacity: 1;\n        }\n\n        &::placeholder {\n          color: ", ";\n        }\n      }\n    "], ["\n      min-height: ", "px;\n      padding: ", "px;\n      border-radius: ", "px;\n      background-color: ", ";\n\n      textarea {\n        display: block;\n        width: 100%;\n        resize: none;\n        border: none;\n        outline: none;\n        font-size: ", "px;\n        background-color: transparent;\n        color: ", ";\n\n        &:disabled {\n          color: ", ";\n          // iOS Safari fix\n          -webkit-text-fill-color: ", ";\n          opacity: 1;\n        }\n\n        &::placeholder {\n          color: ", ";\n        }\n      }\n    "])), minHeight, foundation/* Spacing.medium */.Ki.medium, foundation/* Radius.medium */.wU.medium, isDisabled ? theme.var.gray100 : theme.var.gray50, fontSize, theme.var.black, theme.var.gray400, theme.var.gray400, theme.var.gray600);
    };
};
var Textarea = (0,react.forwardRef)(function (_a, ref) {
    var className = _a.className, _b = _a.fontSize, fontSize = _b === void 0 ? foundation/* FontSizes.medium */.TS.medium : _b, props = Textarea_rest(_a, ["className", "fontSize"]);
    var minRows = props.minRows, disabled = props.disabled;
    var _minRows = minRows !== null && minRows !== void 0 ? minRows : 3;
    var minHeight = _minRows * (fontSize + 2) + 2;
    return ((0,emotion_react_jsx_runtime_browser_esm.jsx)("div", Textarea_assign({ className: className, css: textareaCSS(fontSize, minHeight, disabled !== null && disabled !== void 0 ? disabled : false) }, { children: (0,emotion_react_jsx_runtime_browser_esm.jsx)(react_textarea_autosize_browser_esm/* default */.Z, Textarea_assign({ ref: ref }, props)) })));
});
/* harmony default export */ var form_Textarea = ((/* unused pure expression or super */ null && (Textarea)));
var Textarea_templateObject_1;
//# sourceMappingURL=Textarea.js.map
;// CONCATENATED MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/index.js



//# sourceMappingURL=index.js.map

/***/ }),

/***/ 83280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var _components_common_RoundAvatar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81794);
/* harmony import */ var _components_common_SwipableListContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95728);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 40px;\n\n  ",
        " {\n    width: 48px;\n  }\n  ",
        " {\n    width: 56px;\n  }\n\n  .image-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 100px;\n    position: relative;\n    overflow: hidden;\n\n    ",
        " {\n      width: 48px;\n      height: 48px;\n    }\n    ",
        " {\n      width: 56px;\n      height: 56px;\n    }\n  }\n  .selected {\n    border: 2px solid ",
        ";\n  }\n  .name {\n    color: ",
        ";\n    font-family: 'Apple SD Gothic Neo';\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n\n    margin-top: 5px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  gap: 11px;\n  padding: 6px 0px;\n\n  ",
        " {\n    gap: 14px;\n    padding: 8px 0px;\n  }\n  ",
        " {\n    gap: 16px;\n    padding: 10px 0px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var cardContainerCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), _styles_css__WEBPACK_IMPORTED_MODULE_2__/* .media.tablet */ .BC.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_2__/* .media.desktop */ .BC.desktop, _styles_css__WEBPACK_IMPORTED_MODULE_2__/* .media.tablet */ .BC.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_2__/* .media.desktop */ .BC.desktop, theme.colors.main500, theme.var.gray700);
};
var gridContainerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject1(), _styles_css__WEBPACK_IMPORTED_MODULE_2__/* .media.tablet */ .BC.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_2__/* .media.desktop */ .BC.desktop);
var SwipeableCharacterList = function(param) {
    var characterList = param.characterList, selectedCharacter = param.selectedCharacter, onClickCharacter = param.onClickCharacter;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_common_SwipableListContainer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "character-container",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "grid-container",
            css: gridContainerCSS,
            children: characterList === null || characterList === void 0 ? void 0 : characterList.map(function(item, idx) {
                /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
                    css: cardContainerCSS,
                    onClick: function() {
                        return onClickCharacter && onClickCharacter(item);
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                            className: "image-container ".concat((selectedCharacter === null || selectedCharacter === void 0 ? void 0 : selectedCharacter.id) === item.id ? "selected" : "non-selected"),
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_common_RoundAvatar__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                                picture: item === null || item === void 0 ? void 0 : item.profile_image,
                                size: 40
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                            className: "name ellipsis",
                            children: item.name
                        })
                    ]
                }, "info_list_".concat(idx));
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SwipeableCharacterList);


/***/ }),

/***/ 81794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var _components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92145);
/* harmony import */ var _components_common_SvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34368);
/* harmony import */ var _public_icons_profile_32_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42079);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n  border-radius: 100px;\n  overflow: hidden;\n  img {\n    ",
        ";\n  }\n\n  i {\n    display: block;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var avatarWrapCSS = function(size) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), size, size);
};
var avatarCSS = function(size, blurValue) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject1(), size, size, blurValue ? "filter: blur(".concat(blurValue, "px)") : null);
};
var RoundAvatar = function(param) {
    var _size = param.size, size = _size === void 0 ? 44 : _size, picture = param.picture, className = param.className, blurValue = param.blurValue, _imageSize = param.imageSize, imageSize = _imageSize === void 0 ? _components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__/* .EFinderImageSizes.avatar */ .ny.avatar : _imageSize;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        css: avatarWrapCSS(size),
        className: className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            css: avatarCSS(size, blurValue),
            className: "avatar-container",
            children: picture && picture.key ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
                image: picture,
                h: imageSize,
                radius: 100
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_common_SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                icon: _public_icons_profile_32_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                d: size
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RoundAvatar);


/***/ }),

/***/ 95728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
// SwipeableListContainer.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var listContainerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject());
var SwipeableListContainer = function(param) {
    var children = param.children, className = param.className;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var isDragging = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var startX = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var scrollLeft = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var el = containerRef.current;
        if (!el) return;
        var handleMouseDown = function(e) {
            isDragging.current = true;
            startX.current = e.pageX - el.offsetLeft;
            scrollLeft.current = el.scrollLeft;
            el.style.cursor = "grabbing";
        };
        var handleMouseMove = function(e) {
            if (!isDragging.current) return;
            e.preventDefault();
            var x = e.pageX - el.offsetLeft;
            var walk = (x - startX.current) * 1.2;
            el.scrollLeft = scrollLeft.current - walk;
        };
        var handleMouseUp = function() {
            isDragging.current = false;
            el.style.cursor = "grab";
        };
        el.addEventListener("mousedown", handleMouseDown);
        el.addEventListener("mousemove", handleMouseMove);
        el.addEventListener("mouseleave", handleMouseUp);
        el.addEventListener("mouseup", handleMouseUp);
        return function() {
            el.removeEventListener("mousedown", handleMouseDown);
            el.removeEventListener("mousemove", handleMouseMove);
            el.removeEventListener("mouseleave", handleMouseUp);
            el.removeEventListener("mouseup", handleMouseUp);
        };
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        css: listContainerCSS,
        className: className,
        ref: containerRef,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SwipeableListContainer);


/***/ }),

/***/ 37666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ useFirebase; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
// EXTERNAL MODULE: ./constants/index.ts + 2 modules
var constants = __webpack_require__(45432);
;// CONCATENATED MODULE: ./utils/namespace.ts

var getCurationNamespace = function(router) {
    var title = router.query.title;
    var subSections = [];
    try {
        subSections = JSON.parse(router.query.sub_sections) || [];
    } catch (error) {
        subSections = [];
    }
    var subSectionIndex = 0;
    try {
        subSectionIndex = parseInt(router.query.sub_section_index) || 0;
    } catch (err) {
        subSectionIndex = 0;
    }
    var sectionId = 0;
    try {
        sectionId = subSections.length ? subSections[subSectionIndex].id : parseInt(router.query.sectionId);
    } catch (err1) {
        sectionId = 0;
    }
    var _section_type;
    var sectionType = (_section_type = router.query.section_type) !== null && _section_type !== void 0 ? _section_type : constants/* SectionType.original */.bA.original;
    if (subSections === null || subSections === void 0 ? void 0 : subSections.length) {
        var subSection = subSections === null || subSections === void 0 ? void 0 : subSections.find(function(s) {
            return s.id === sectionId;
        });
        if (subSection) {
            var id = subSection.id, name = subSection.name;
            var subPath = "".concat(name, "(").concat(id, ")").replace("/", "+");
            return sectionType === constants/* SectionType.standard */.bA.standard ? "홈/스탠다드/".concat(title, "/더보기/").concat(subPath) : "홈/오리지널/".concat(title, "/더보기/").concat(subPath);
        }
    }
    return sectionType === constants/* SectionType.standard */.bA.standard ? "홈/스탠다드/".concat(title, "/더보기") : "홈/오리지널/".concat(title, "/더보기");
};
var getSearchResultNamespace = function(router) {
    var tab = router.query.tab;
    switch(tab){
        case "story":
            return "검색결과/작품";
        case "user":
            return "검색결과/작가";
        case "tag":
            return "검색결과/태그";
        default:
            return "검색결과";
    }
};
var getSearchNamespace = function(router) {
    var tab = router.query.tab || "recommend";
    if (tab === "recommend") {
        return "검색/AI추천";
    }
    return "검색/카테고리(".concat(tab, ")");
};
var getLibraryNamespace = function(router) {
    var tab = router.query.tab || "read-stories";
    switch(tab){
        case "following-feed":
            return "내서재/팔로잉";
        case "liked-stories":
            return "내서재/좋아요";
        case "chat-library":
            return "내서재/플레이";
        default:
            return "내서재/읽은작품";
    }
};
var getPlayNamespace = function() {
    return "플레이/캐릭터 상세";
};
var getUsersNamespace = function() {
    return "작가상세/작품";
};
var getStoryListByTagsNamespace = function(router) {
    var tab = router.query.tab || "popular";
    return tab === "popular" ? "작품상세/태그상세/인기작품" : "작품상세/태그상세/최신작품";
};
var getPageNamespace = function(router) {
    var currentPath = router.asPath;
    var pathCheckers = [
        {
            regex: /\/curations\/\d+/,
            getNamespace: getCurationNamespace
        },
        {
            regex: /\/search\/(.+)/,
            getNamespace: getSearchResultNamespace
        },
        {
            regex: /\/search/,
            getNamespace: getSearchNamespace
        },
        {
            regex: /\/library/,
            getNamespace: getLibraryNamespace
        },
        {
            regex: /\/play\/characters\/\d+/,
            getNamespace: getPlayNamespace
        },
        {
            regex: /\/users\/\d+/,
            getNamespace: getUsersNamespace
        },
        {
            regex: /\/tags\/\d+\/stories/,
            getNamespace: getStoryListByTagsNamespace
        }, 
    ];
    var matchedPath = pathCheckers.find(function(pathChecker) {
        return currentPath.match(pathChecker.regex);
    });
    var ref;
    return (ref = matchedPath === null || matchedPath === void 0 ? void 0 : matchedPath.getNamespace(router)) !== null && ref !== void 0 ? ref : "기타페이지";
};

;// CONCATENATED MODULE: ./hooks/useFirebase.ts





var useFirebase = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,hook/* useMe */.Pi)(), user = ref.data;
    var firebase = (0,analytics/* useAnalytics */.z$)().firebase;
    var inflow = (0,react.useCallback)(function(id, options) {
        if (!user) {
            return;
        }
        var ref;
        firebase.logEvent("story_inflow", {
            storyId: id,
            userId: user.id,
            userCreated: user.created,
            path: (ref = options === null || options === void 0 ? void 0 : options.path) !== null && ref !== void 0 ? ref : getPageNamespace(router)
        });
    }, [
        router,
        user
    ]);
    return {
        inflow: inflow
    };
};


/***/ }),

/***/ 42079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgProfile32 = function SvgProfile32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#E5E5E5",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.077 11.692a4.923 4.923 0 1 0 9.846 0 4.923 4.923 0 0 0-9.846 0m8.26 7.385c2.576 0 4.663 2.755 4.663 6.154H8c0-3.4 2.087-6.154 4.663-6.154h6.674",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgProfile32);

/***/ })

}]);